module.exports = __webpack_public_path__ + "static/media/3.61f4fb53.svg";